import { useState } from 'react'
import { HiX, HiLightBulb, HiArrowRight } from 'react-icons/hi'

export default function WelcomeBanner({ userName, onStartTour, onDismiss }) {
  const [isVisible, setIsVisible] = useState(true)

  const handleDismiss = () => {
    setIsVisible(false)
    onDismiss?.()
  }

  if (!isVisible) return null

  return (
    <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-brand-600 via-brand-500 to-purple-600 text-white p-6 mb-6 shadow-lg">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
            <circle cx="5" cy="5" r="1" fill="currentColor" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>
      
      {/* Close button */}
      <button
        onClick={handleDismiss}
        className="absolute top-4 right-4 p-1 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
        aria-label="Dismiss"
      >
        <HiX className="w-4 h-4" />
      </button>
      
      {/* Content */}
      <div className="relative flex items-center gap-6">
        <div className="hidden sm:flex items-center justify-center w-16 h-16 rounded-full bg-white/20 backdrop-blur">
          <span className="text-3xl">👋</span>
        </div>
        
        <div className="flex-1">
          <h2 className="text-xl font-bold mb-1">
            Welcome to Salt & Straw Project Tracker{userName ? `, ${userName}` : ''}!
          </h2>
          <p className="text-white/80 mb-4">
            We're thrilled to have you here. Let's get you started with a quick tour of the platform.
          </p>
          
          <div className="flex flex-wrap items-center gap-3">
            <button
              onClick={onStartTour}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white text-brand-600 font-semibold hover:bg-white/90 transition-colors"
            >
              <HiLightBulb className="w-5 h-5" />
              Take the Tour
              <HiArrowRight className="w-4 h-4" />
            </button>
            <button
              onClick={handleDismiss}
              className="text-white/80 hover:text-white text-sm underline underline-offset-2"
            >
              I'll explore on my own
            </button>
          </div>
        </div>
      </div>
      
      {/* Quick stats teaser */}
      <div className="relative mt-6 pt-4 border-t border-white/20">
        <div className="flex flex-wrap gap-6 text-sm">
          <div>
            <span className="text-white/60">Quick tip:</span>
            <span className="ml-2">Press <kbd className="px-1.5 py-0.5 rounded bg-white/20 text-xs">Ctrl+K</kbd> to search anywhere</span>
          </div>
          <div>
            <span className="text-white/60">Or try:</span>
            <span className="ml-2">Ask HAL 9000 to create your first task</span>
          </div>
        </div>
      </div>
    </div>
  )
}
